import { bindActionCreators } from '@reduxjs/toolkit'
import { actions as addressActions } from 'feature/addresses/redux/AddressSlice'
import { actions as appealFormActions } from 'feature/appeals/redux/AppealFormSlice'
import { actions as appealsActions } from 'feature/appeals/redux/EditableAppealSlice'
import { actions as authActions } from 'feature/auth/redux/authSlice'
import { actions as orderNewFormActions } from 'feature/productOrder/redux/orderFormSlice'
import { actions as serviceAction } from 'feature/serviceCenters/redux/ServiceCentersSlice'
import { actions as mapActions } from 'feature/YandexMap/redux/YandexMapSlice'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store/types'
import { actions as noticeAction } from 'widget/Notifications/store'

const rootActions = {
  ...mapActions,
  ...addressActions,
  ...orderNewFormActions,
  ...authActions,
  ...noticeAction,
  ...appealsActions,
  ...serviceAction,
  ...appealFormActions,
}

// хук которым можно вытащить любой action в проекте
// внимание на название actions, не должны пересекаться между слайсами
export const useActions = () => {
  const dispatch: AppDispatch = useDispatch<AppDispatch>()
  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch])
}
